import { ENVIRONMENTS } from 'services/getEnvironmentalVariables';
import { config } from '../../config';

export const getCookie = (key: string): string | undefined => document.cookie
    .split('; ')
    .find(pair => pair.startsWith(`${key}=`))
    ?.split('=')[1];

export const setCookie = (key: string, value: string, attributes: string = 'path=/') => {
    document.cookie = `${key}=${value}; ${attributes}`;
};

export const removeCookie = (key: string) => {
    document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const setCrossDomainCookie = (
    key: string,
    value: string,
    maxAge: number = 2592000,
) => {
    const isLocal = config.environment === ENVIRONMENTS.DEV;

    const domain = isLocal ? '' : '.northspyre.com';

    const attributes = [
        'path=/',
        'SameSite=None',
        'Secure',
        `Max-Age=${maxAge}`,
    ];

    if (domain) {
        attributes.push(`domain=${domain}`);
    }

    setCookie(key, value, attributes.join('; '));
};
